import './Stakeholder.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Sidebar, Content as ContentLayout, Wrapper } from './layout'
import { TabDeclarations, TabNewRequest, TabTasks, TabOnboarding, TabCdiForms, TabBenFinales, TabProfile } from './components'
import { Page, PageContent, PageHeader, Content } from '../../layouts/Private/components'
import { Button, Icon } from 'antd'
import { ReportService } from '../../services/'
import {getEstadoTareasUserPromise} from './promises'

const StakePrivate = ({ client, currentUser, user, externalActiveTab, profileOpenTrigger, refreshUser }) => {
	const { t } = useTranslation(["translations", "forms"]);
	const [activeTab, setActiveTab] = useState('')
	const [content, setContent] = useState(null)
	const [edoTasks,setEdoTasks] = useState(null)
	const isInactiveUser = currentUser?.status === 'INACTIVE'

	const handleTabChange = (tab) => {
		setActiveTab(tab)
	}

	useEffect(() => {
		if (externalActiveTab) {
			setActiveTab(externalActiveTab)
		}
	}, [externalActiveTab, profileOpenTrigger])

	useEffect(() => {
		if(edoTasks && activeTab === '') {
			if(edoTasks.PENDIENTE > 0) {
				setActiveTab('tab-tasks-PENDIENTE')
			}else if(edoTasks.EN_PROCESO > 0) {
				setActiveTab('tab-tasks-EN_PROCESO')
			}else if(edoTasks.TERMINADO > 0) {
				setActiveTab('tab-tasks-TERMINADO')
			}
		}
	}, [edoTasks])

	useEffect(() => {
		if	(client?.modules?.includes("MONITOR")){
			getEstadoTareasUserPromise(currentUser.id).then(res=>{
				setEdoTasks(res.data)
			})
		}
		if (client?.modules?.includes('CDI-FORM'))
			setActiveTab('tab-newdeclaraciones')
		else if (client?.modules?.includes('ONBOARDING')) {
			setActiveTab('tab-onboarding')
		}
	}, [])

	const exportForms = () => {
		ReportService.read('/portal/excelCDIDeclarationsByRecordId/' + currentUser.id, null, null, "declaraciones.xlsx")
	}

	const changeContent = (component) => {
		setContent(component)
	}

	const changeTabHeaderAction = () => {
		handleTabChange('tab-declaraciones');
	}

	return (
		<div className="stakeholder-private">
			<Content>
				{ content !== null ?
					content
				:
				<>
					<Page>
						<PageHeader
							title={t('messages.aml.usersPortal')+": "+currentUser.nombre}
							description={ t('messages.aml.category.' + currentUser.category) }
							icon="user"
							formAction={changeTabHeaderAction.bind(this)}
							/>
						<PageContent className="minisite-stakeholder">
							<Wrapper>
								<Sidebar client={client} currentUser={currentUser} activeTab={ activeTab } onTabChange={ handleTabChange } edoTasks = {edoTasks} />
								<ContentLayout>
								{isInactiveUser &&
									<div className="inactive-user-banner" role="alert">
										<div className="inactive-user-banner-icon">
											<Icon type="stop" />
										</div>
										<div className="inactive-user-banner-content">
											<h4>{t('portal.cdi.inactive.banner.title', {ns: 'forms'})}</h4>
											<p>{t('portal.cdi.inactive.banner.description', {ns: 'forms'})}</p>
										</div>
									</div>
								}
								{ activeTab === 'tab-newdeclaraciones' &&
									<TabCdiForms client={client} currentUser={currentUser} />
								}
								{ activeTab === 'tab-beneficiarios-finales' &&
									<TabBenFinales currentUser={currentUser}/>
								}
								{ activeTab === 'tab-old-decl' &&
									<TabNewRequest client={client} currentUser={currentUser} />
								}
								{ activeTab === 'tab-declaraciones' &&
									<TabDeclarations client={client} currentUser={currentUser} />
								}
								{ activeTab.startsWith ('tab-tasks-') &&
									<TabTasks key={activeTab} status={activeTab.substring(10)} currentUser={currentUser} callback={changeContent}/>
								}
								{ activeTab === 'tab-reporte' &&
									<div style={{padding: '0px 10px'}}>
										<Button type="primary" icon="file-excel" onClick={exportForms}>Descargar Reporte</Button>
									</div>
								}
								{ activeTab === 'tab-onboarding' &&
									<div>
										<TabOnboarding client={client} currentUser={currentUser}/>
									</div>
								}
								{ activeTab === 'tab-profile' &&
									<TabProfile user={user} onChangeTab={handleTabChange} refreshUser={refreshUser} />
								}
								{ activeTab === 'home' &&
									<div className="stakeholder-home-welcome">
										<div className="stakeholder-home-card">
											<h2 className="stakeholder-home-title">
												{t('portal.home.welcome')}
											</h2>
											<p className="stakeholder-home-subtitle">
												{t('portal.home.description')}
											</p>
											<div className="stakeholder-home-actions">
												{client?.modules?.includes('CDI-FORM') &&
													<Button
														type="primary"
														icon="file-text"
														disabled={isInactiveUser}
														onClick={() => handleTabChange('tab-newdeclaraciones')}
													>
														{t('portal.home.newDeclaration')}
													</Button>
												}
												{client?.modules?.includes('MONITOR') &&
													<Button
														icon="unordered-list"
														onClick={() => handleTabChange('tab-tasks-PENDIENTE')}
													>
														{t('portal.home.myTasks')}
													</Button>
												}
												<Button
													icon="user"
													onClick={() => handleTabChange('tab-profile')}
												>
													{t('portal.home.myProfile')}
												</Button>
											</div>
										</div>
									</div>
								}
							</ContentLayout>
							</Wrapper>
						</PageContent>
					</Page>
				</>
				}
			</Content>
		</div>
	)
}

export default StakePrivate
